export default "__VITE_ASSET__0q8WjiKS__"